import React, { Suspense, useEffect, useState  } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Loader from './Loader';
import IsotopeReact from './IsotopeReact';
import axiosInstance, { API_ENDPOINTS, HOST_API } from '../axios/axiosInstance';
import TabelaAlergenos from './TabelaAlergenos';
import SEO from './SEO';

const Menu = () => {
  const { t } = useTranslation();
  const [menuData, setMenuData] = useState(null);

  // Filter daily dishes to show only today's dish
  const filterTodaysDish = (data) => {
    if (!data) return data;

    const today = new Date().getDay(); // 0 = Sunday, 1 = Monday, etc.

    return data.map(menu => {
      // Filter dishes that have dayOfWeek set - only show today's
      if (menu.dishs) {
        const filteredDishs = menu.dishs.filter(dish => {
          // If dish has dayOfWeek, only show if it matches today
          if (dish.dayOfWeek !== null && dish.dayOfWeek !== undefined) {
            return dish.dayOfWeek === today;
          }
          // If no dayOfWeek, always show
          return true;
        });
        return {
          ...menu,
          dishs: filteredDishs
        };
      }
      return menu;
    }).filter(menu => {
      // Remove menu if no dishes
      return menu.dishs && menu.dishs.length > 0;
    });
  };

  const fetchData = async () => {
    try {
      const res = await axiosInstance.get(HOST_API+API_ENDPOINTS.menu.restaurant);
      setMenuData(filterTodaysDish(res.data));
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  useEffect(() => {
     fetchData();

  }, []);
  
  return (
    <Suspense fallback={ <Loader />}>
    <SEO
      titleKey="seo.menuTitle"
      descriptionKey="seo.menuDescription"
      path="/menu"
    />
    <section className="banner dark" >
    <div id="menu-parallax">
      <div className="bcg background43"
                data-center="background-position: 50% 0px;"
                data-bottom-top="background-position: 50% 100px;"
                data-top-bottom="background-position: 50% -100px;"
                data-anchor-target="#menu-parallax"
              >
        <div className="bg-transparent">
          <div className="banner-content">
            <div className="container" >
              <div className="slider-content  " style={{paddingTop:'160.5px'}}>
                <h1>{t('menu.title')}</h1>
                <p>{t('menu.subtitle')}</p>
                <ol className="breadcrumb">
                  <li><Link to='/'>{t('nav.home')}</Link></li>
                  <li>{t('menu.breadcrumb')}</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section className="padding-b-50 text-center masonry_menu masonry_columm">
  <div className="container">
       <div className="menu-bar">
       {menuData !== null ?
       <IsotopeReact
         categories={menuData.map((menu) => ({
           name: menu.menuType,
           frenchName: menu.menuTypeFrench,
           englishName: menu.menuTypeEnglish
         }))}
         items={menuData
           .map(obj => obj.dishs.map(dish => ({
             ...dish,
             menuType: obj.menuType,
             menuTypeFrench: obj.menuTypeFrench,
             menuTypeEnglish: obj.menuTypeEnglish,
             menuTypeOrder: obj.order
           })))
           .reduce((acc, dishArray) => acc.concat(dishArray), [])}
       /> : null }
<TabelaAlergenos />
      
      </div>
</div>
<br/>
    </section>
    </Suspense>
  );
};

export default Menu;